import __ from 'utils/lang'
export default {
	// The install method will be called with the Vue constructor as the first argument, along with possible options
	install(Vue, options) {
		// Add $plugin instance method directly to Vue components
		Vue.prototype.$t = (str, variables) =>  __(str, variables)
	}
}
